export function synchroLinkBuilder(
  synchroBaseUrl: string,
  contextId: string,
  selectionState?: string
): string {
  if (!synchroBaseUrl.endsWith('/')) {
    synchroBaseUrl += '/';
  }

  const link = `${synchroBaseUrl}${contextId}/documents/pwlink`;

  if (selectionState) {
    return `${link}/${selectionState}`;
  }

  return link;
}

export function pw365LinkBuilder(
  pw365BaseUrl: string,
  contextId: string,
  selectionState?: string
): string {
  if (!pw365BaseUrl.endsWith('/')) {
    pw365BaseUrl += '/';
  }

  const link = `${pw365BaseUrl}${contextId}/documents/documents-connections`;

  if (selectionState) {
    return `${link}/v2/${selectionState}`;
  }

  return link;
}

export function infrastructurePortalLinkBuilder(
  portalBaseUrl: string,
  contextId: string,
  selectionState?: string
): string {
  if (!portalBaseUrl.endsWith('/')) {
    portalBaseUrl += '/';
  }

  const link = `${portalBaseUrl}${contextId}`;

  if (selectionState) {
    return `${portalBaseUrl}${contextId}/documents/pwlink/${selectionState}`;
  }
  return link;
}
